module.exports = __webpack_public_path__ + "static/media/car_1.037a2fd3.svg";